import { Component, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ConnectivityService } from '../../core/connectivity.service';
import { IconComponent } from '../icon/icon.component';

/** Global banner shown when a request fails to reach the server (network/5xx) - see ConnectivityService. */
@Component({
  selector: 'app-error-banner',
  standalone: true,
  imports: [TranslatePipe, IconComponent],
  templateUrl: './error-banner.component.html',
  styleUrl: './error-banner.component.scss'
})
export class ErrorBannerComponent {
  readonly connectivity = inject(ConnectivityService);

  reload(): void {
    window.location.reload();
  }
}
